module.exports = __webpack_public_path__ + "img/landing.48dafc59.jpg";